import React from 'react';
import PropTypes from 'prop-types';
import User from "../../models/User";
import UserImageCircle from "../UserImageCircle";
import InfoTooltip from '../InfoTooltip';

const getCalenderFormatForLastSeen = (dateTime, format = 'hh:mma', needToConvertLocalDate = 1) => {
    let date = (needToConvertLocalDate) ? TB.moment(dateTime).local() : TB.moment(dateTime);
    return date.calendar(null, {
        sameDay: '[Today], ' + format,
        lastDay: '[Yesterday], ' + format,
        lastWeek: 'dddd, ' + format,
        sameElse: () => {
            if (TB.moment().year() === TB.moment(dateTime).year()) {
                return 'MMM D, ' + format;
            } else {
                return 'MMM D YYYY, ' + format;
            }
        },
    });
};


const Message = ({message}) => {
    let sender = message.sender ? User.make({...message.sender}) : null;
    const auth = TB.auth().user();

    if (!sender) {
        sender = User.make({image_path: '/images/alt_user.png', first_name: 'Wripple', last_name: 'System', id: 0})
        // return (
            // <div className="chat__msg-day-divider system-message flex justify-center">
            //     <span className="chat__msg-day-title text-dark">
            //         <small>{message.content}</small>
            //     </span>
            //     <span className="time-date">{getCalenderFormatForLastSeen(message.sent_at)}</span>
            // </div>
        // )
    }

    const flagAbuse = async () => {
        const request = TB.request(`/api/conversations/messages/${message.id}/flag`);
        await request.post().catch(err => {
            console.warn('ERROR: flag abuse', err);
            return TB.showServerErrorToast();
        });

        TB.toast("Message has been flagged for abuse", {type: 'info'});
    }

    const readRecipients = TB.filter(message.recipients || [], 'has_viewed');

    return (
        <div id="send-receive-direction" key={"message" + message.sent_at}
             className={TB.mapClass({
                 'chat-conversation__system': sender?.id === 0,
                 'chat-conversation__sender': sender?.id === auth?.id,
                 'chat-conversation__receiver': sender?.id !== auth?.id,
                 'unread': sender?.id !== 0 && sender?.id !== auth?.id && !message.last_viewed_at
             })}>
            {sender && (
                <div className="chat-conversation__avatar">

                    <UserImageCircle
                        className={"img-fluid img-grayscale conversation-user-img user-chat-image-" + sender.id}
                        size={35}
                        user={sender}/>
                </div>
            )}

            <div
                className="chat-conversation__bubble clearfix">
                <div className="chat-conversation__bubble-text message">
                    {message.attachment_path && (
                        <div className={TB.mapClass("flex-center-column", {
                            "mb-2 border-b": message.content
                        })}>
                            <i className="fa fa-file-alt fa-4x text-primary"/>
                            <small className="mt-2">
                                {(new URL(message.attachment_path)).pathname.substring(
                                    new URL(message.attachment_path).pathname.lastIndexOf("/") + 1
                                )}
                            </small>

                        </div>
                    )}

                    <div className="clearfix"/>
                    {message.content && (
                        <div dangerouslySetInnerHTML={{__html: TB.replace(String(message.content),/<p><\/p>/gi, "<br />")}}></div>
                    )}

                </div>
                <div className="chat-container__time whitespace-nowrap chat-time">
                    <span className="time-sender">{sender.firstNamePlusInitial()}</span>
                    <span className="time-date">{getCalenderFormatForLastSeen(message.sent_at)}</span>
                </div>
                <div className="chat-container__read-status absolute">

                    <i
                        id={`recipient_${message.id}`}
                        aria-hidden="true"
                        className={!!readRecipients?.length ? '--read fas fa-eye' : 'fas fa-check'}
                    />

                         <InfoTooltip type="dark" target={`recipient_${message.id}`}>
                             {!!readRecipients.length ? (
                                     <React.Fragment>
                                         <p className="p-0 m-0 text-left text-white font-bold">Seen by:</p>

                                         <ul className="chat-has-been-read-tooltip">

                                             {readRecipients.map(recipient => {
                                                 if (recipient.id === auth?.id) return;

                                                 return (
                                                     <li key={recipient.id} className="p-0 m-0">
                                                         {recipient.name}
                                                     </li>
                                                 )
                                             })}
                                         </ul>
                                     </React.Fragment>
                             ) : (
                                 <p className="p-0 m-0 text-left text-white font-bold">Sent</p>
                             )}
                        </InfoTooltip>


                </div>
            </div>
            {sender && sender.id !== 0 && sender.id !== auth?.id && (
                <div className="chat-conversation__menu flex items-center">
                    <div className="dropdown btn-group msg-options">
                        <i className="fa fa-ellipsis-v " data-toggle="dropdown" aria-haspopup="true"
                           aria-expanded="false"/>
                        <div className="dropdown-menu">

                            <button
                                onClick={flagAbuse}
                                className="dropdown-item msg-delete-icon"
                            >
                                Flag Abuse
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
};

Message.propTypes = {
    message: PropTypes.object,
    auth: PropTypes.object
};

export default Message;